import Loader from '../common/Loader/Loader';

/**
 * Component to display a loader while authentication is in progress.
 */
export const AuthenticationLoader: React.FC = () => {
  return (
    <div className="h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <div className="flex min-h-40 bg-white p-6 gap-2">
          <Loader show={true} className="text-white" spin />
          <h1 className="text-xl font-semibold text-gray-700">Authentication in progress...</h1>
        </div>
      </div>
    </div>
  );
};
